<div class="dropdown {{ customCssClasses.dropdownContainer }}">
    <a class="{{ customCssClasses.button }} user-select-none" [style]="{ 'pointer-events': blockInput ? 'none' : 'auto' }"
       [ngClass]="{'dropdown-toggle': showDropdownToggle}"
       ycnDisabled [disabled]="!!inputDisabled"
       (click)="toggle()"
       href="javascript:void(0)">
        @if (!customLabel) {
            <span>
                <span class="{{ !isInHeader ? 'text-default' : '' }} {{ customCssClasses.placeholder ?? 'placeholder' }}" *ngIf="placeholderText && !selectedItem" [textContent]="placeholderText"></span>
                <span class="{{ !isInHeader ? 'text-default' : '' }}" *ngIf="configCopy.title?.label" [textContent]="configCopy.title?.label + ': '"></span>
                <span class="{{ !isInHeader ? 'text-default' : '' }} {{ customCssClasses.dropdownItem }}" [ngClass]="{'dropdown-more': !!configCopy.title?.label}"
                      *ngIf="!!selectedItem?.label || !!selectedItem?.selectedLabel"
                      [textContent]="selectedItem?.selectedLabel ?? selectedItem?.label"></span>
            </span>
        }
        @if (customLabel && !isCollapsible) {
            <span>
                <span class="{{ !isInHeader ? 'text-default' : '' }} {{ customCssClasses.dropdownItem }}" [textContent]="customLabel"></span>
                <span *ngIf="!!customSublabel" class="text-normal visible-md-inline" [textContent]="customSublabel"></span>
            </span>
        }
        @if (customLabel && isCollapsible) {
            {{customLabel}}<span class="text-normal visible-md-inline" [textContent]="customSublabel"></span>
        }
    </a>
    <div
            #singleSelectDropdownMainMenu
            [ycnAppendToBody]="appendToBody"
            [ngClass]="{show: isOpen}"
            class="dropdown-menu {{ customCssClasses.dropdownMenu }}"
    >
        <div *ngFor="let listItem of configCopy.list" [ngSwitch]="listItem.type">
            <div class="dropdown-divider" *ngSwitchCase="'divider'"></div>
            <div *ngSwitchDefault>
                <ng-container *ngIf="scrollToSelected">
                    <span *ngIf="listItem.selected" #scrollTargetEl></span>
                </ng-container>
                <div [ngSwitch]="!!listItem.sublist">
                    <label class="custom-control custom-checkbox dropdown-item custom-checkbox-style1"
                           [ngClass]="{'custom-checkbox-tall': listItem.description}"
                           ycnDisabled [disabled]="listItem.disabled"
                           *ngSwitchCase="false">
                        <input class="custom-control-input"
                               type="checkbox"
                               (change)="handleChange(listItem)"
                               [(ngModel)]="listItem.selected">
                        <span class="custom-control-indicator"></span>
                        <span *ngIf="listItem.description" class="custom-control-description dropdown-item-text">
                            {{ listItem.label }}
                            <div class="dropdown-item-description" [textContent]="listItem.description"></div>
                        </span>
                        <span *ngIf="!listItem.description" class="custom-control-description" [textContent]="listItem.label"></span>
                        <ng-container *ngIf="listItem.helpName">
                            <span>&nbsp;</span>
                            <span class="help-toggler" (click)="helpModal.openModal(listItem.helpName); false">(?)</span>
                        </ng-container>
                    </label>
                    <div class="dropdown-item dropdown"
                        [ngClass]="{show: !!listItem.open}"
                         ycnDisabled [disabled]="listItem.disabled"
                        *ngSwitchCase="true"
                        (click)="toggleSublist(listItem)">
                        <div class="dropdown-toggle" [innerHTML]="listItem.label"></div>
                        <div class="dropdown-menu" [ngClass]="{show: !!listItem.open}">
                            <label *ngFor="let sublistItem of listItem.sublist"
                                   class="custom-control custom-checkbox dropdown-item custom-checkbox-style1"
                                   [ngClass]="{'disabled': sublistItem.disabled}">
                                <input class="custom-control-input"
                                       type="checkbox"
                                       (change)="handleChange(sublistItem)"
                                       [disabled]="!!sublistItem.disabled"
                                       [(ngModel)]="sublistItem.selected">
                                <span class="custom-control-indicator"></span>
                                <span class="custom-control-description"
                                    [innerHTML]="sublistItem.label"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ycn-help-modal #helpModal></ycn-help-modal>
<ycn-feature-needed></ycn-feature-needed>
